import { CircularProgress, Grid, makeStyles, TextField } from '@material-ui/core';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import AlertMessage from 'app/components/AlertMessage';
import FinalizeButton from 'app/components/FinalizeButton';
import { SERVICES_CODES } from 'app/config/services';
import { fetchSubitemComponent, fetchSystemClassification } from 'app/store/slices/survey';
import { FormServiceContext } from 'app/utils/contexts';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactForm from '../Survey/ContactForm';
import SurveyData from '../Survey/SurveyData';
import SearchRequest from './SearchRequest';

import styles from './styles';
const useStyles = makeStyles(styles);

const InspectionReportRegistration = props => {
  const formContactRef = useRef();
  const dispatch = useDispatch();

  const classes = useStyles();
  const contextProps = useContext(FormServiceContext);
  const [requestSelected, setRequestSelected] = useState(null);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [city, setCity] = useState('');
  const [loading, setLoading] = useState(false);

  const systemClassification = useSelector(state => state.survey.systemClassification);
  const subitemComponent = useSelector(state => state.survey.subitemComponent);
  const request = useSelector(state => state.requests.details);

  useEffect(() => {
    const init = async () => {
      if (
        request?.cdServico &&
        (request.cdServico === SERVICES_CODES.VISTORIA ||
          request.cdServico === SERVICES_CODES.LAUDO_VISTORIA)
      ) {
        setRequestSelected(request);
        handleSelectSurvey(request);
      }
    };
    init();
  }, [request]);

  useEffect(() => {
    const init = async () => {
      const promisses = [];
      if (systemClassification.length === 0) {
        promisses.push(dispatch(fetchSystemClassification()));
      }
      if (subitemComponent.length === 0) {
        promisses.push(dispatch(fetchSubitemComponent()));
      }
      if (promisses.length > 0) {
        await Promise.all(promisses);
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleSelectSurvey = async request => {
    setLoading(true);
    setRequestSelected(request);
    try {
      const response = await surveyEndpoint.getSurveyByRequest(request.cdSolicitacao);
      if (response?.status === 200 && response.data) {
        setSelectedSurvey(response.data);
      }
    } catch (error) {}
    setLoading(false);
  };

  const {
    initialValues,
    validationSchema,
    onSubmit,
    mainColor,
    hideFinalizeBtn,
    canEdit,
    isInternalForm,
  } = contextProps;

  const [reportInitialValue, setReportInitialValue] = useState(initialValues || {});

  useEffect(() => {
    setReportInitialValue(selectedSurvey);
    if (selectedSurvey?.municipio) {
      setCity(selectedSurvey.municipio?.nmMunicipio || '');
    }
  }, [selectedSurvey]);

  if (loading) {
    return (
      <Grid item xs={12} className={classes.centerProgress}>
        <CircularProgress size={18} />
      </Grid>
    );
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={reportInitialValue}
        validationSchema={validationSchema}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={values => onSubmit(requestSelected, selectedSurvey)}
      >
        {props => {
          return (
            <Form className={classes.containerForm}>
              <AlertMessage isInternalForm={isInternalForm} />

              <div className={classes.containerReport}>
                {!selectedSurvey && (
                  <SearchRequest
                    {...props}
                    contextProps={contextProps}
                    handleSelectSurvey={handleSelectSurvey}
                  />
                )}

                {selectedSurvey && (
                  <>
                    <SurveyData
                      {...props}
                      contextProps={contextProps}
                      request={requestSelected}
                      survey={selectedSurvey}
                      handleSelectSurvey={handleSelectSurvey}
                    />

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Município de preferência vistoria"
                        variant="filled"
                        margin="dense"
                        value={city}
                        disabled={true}
                        fullWidth
                      />
                    </Grid>

                    <ContactForm
                      title="Contato para vistoria"
                      initialValues={reportInitialValue}
                      innerRef={formContactRef}
                      canEdit={false}
                      formikBag={{ ...props }}
                    />

                    <FinalizeButton
                      mainColor={mainColor}
                      hideFinalizeBtn={hideFinalizeBtn}
                      isInternalForm={isInternalForm}
                      canEdit={canEdit}
                      onSubmit={() => {}}
                    />
                  </>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default InspectionReportRegistration;
